<template>
  <div class="pie-chart-area">
    <div v-if="draw" class="pie-chart-item">
      <canvas class="chart" :id="`${id}`" :height="calHeight"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "pie-chart",
  props: {
    data: {
      type: [Object, Array],
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      colorPalette: [
        "#fc4949",
        "#4bc91c",
        "#1e1ae3",
        "#41d7f4",
        "#14a6ff",
        "#bababa",
        "#6c84bd",
        "#569adc",
        "#7db5bd",
        "#3c5388",
        "#2667a8"
      ],
      draw: true
    };
  },
  mounted() {
    if (this.data.length > 0) {
      this.draw = true;
      this.createChart(this.id, this.data);
    }
  },
  watch: {
    data(to, from) {
      if (to.length > 0) {
        this.draw = true;
        this.createChart(this.id, this.data);
      } else {
        this.draw = false;
      }
    }
  },
  filters: {
    percent: function(value) {
      if (value) {
        return Number(value).toFixed(2) + " %";
      }

      return "";
    }
  },
  computed: {
    calHeight(){
      let graphWidth = document.getElementById("article-portfolio").clientWidth
      return graphWidth > 760 ? 200 : 111
    }
  },
  methods: {
    createChart(chartId, chartData) {
      if (chartData) {
        var ctx = document.getElementById(chartId);
        var categoriesChart = new Chart(ctx, {
          type: "doughnut",
          data: {
            datasets: [
              {
                data: chartData.map(item => {
                  return item.percent;
                }),
                backgroundColor: this.getColorPalette(chartData.length),
                borderWidth: 0,
              }
            ],
            labels: chartData.map(item => {
              return item.name;
            })
          },
          options: {
            legend: {
              display: false
            },
            layout: {
              padding: {
                left: 50,
                right: 50,
                top: 0,
                bottom: 0
              }
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  let index = tooltipItem.index;
                  return (
                    data.labels[index] +
                    " : " +
                    data.datasets[0].data[index] +
                    "%"
                  );
                }
              }
            }
          },
          plugins: [
            {
              afterDatasetsDraw: function(chart) {
                //Get ctx from string
                let ctx = chart.ctx;
                //Get options from the center object in options
                let sidePadding = 20;
                let sidePaddingCalculated =
                  (sidePadding / 100) * (chart.innerRadius * 2);
                let elementWidth =
                  chart.innerRadius * 2 - sidePaddingCalculated;

                let centerX =
                  (chart.chartArea.left + chart.chartArea.right) / 2;
                let centerY =
                  (chart.chartArea.top + chart.chartArea.bottom) / 2;

                ctx.globalAlpha = 0.5;
                ctx.beginPath();
                ctx.arc(centerX, centerY, elementWidth * 0.7, 0, 2 * Math.PI);
                ctx.fillStyle = "white";
                ctx.fill();
                ctx.globalAlpha = 1;
              }
            }
          ]
        });
      }
    },
    getColorPalette(num) {
      let returnList = [];
      let colorPalette = this.colorPalette;

      for (let i = 0; i < num; i++) {
        returnList.push(colorPalette[i % colorPalette.length]);
      }
      return returnList;
    },
    computeColor(num) {
      let colors = this.colorPalette;
      return this.colorPalette[num % colors.length] || "";
    }
  }
};
</script>

<style lang="scss" scoped>
.pie-chart{
    
    .pie-chart-area{
        margin: 8px auto;
    }
}
</style>
